import { css } from 'styled-components';
// Regular
import poppins400woff from '../../../../client/fonts/poppins/Poppins-Regular.woff';
import poppins400woff2 from '../../../../client/fonts/poppins/Poppins-Regular.woff2';
import poppinsItalic400woff from '../../../../client/fonts/poppins/Poppins-Italic.woff';
import poppinsItalic400woff2 from '../../../../client/fonts/poppins/Poppins-Italic.woff2';
// Semi-Bold
import poppins600woff from '../../../../client/fonts/poppins/Poppins-SemiBold.woff';
import poppins600woff2 from '../../../../client/fonts/poppins/Poppins-SemiBold.woff2';
import poppinsItalic600woff from '../../../../client/fonts/poppins/Poppins-SemiBoldItalic.woff';
import poppinsItalic600woff2 from '../../../../client/fonts/poppins/Poppins-SemiBoldItalic.woff2';
// Bold
import poppins700woff from '../../../../client/fonts/poppins/Poppins-Bold.woff';
import poppins700woff2 from '../../../../client/fonts/poppins/Poppins-Bold.woff2';
import poppinsItalic700woff from '../../../../client/fonts/poppins/Poppins-BoldItalic.woff';
import poppinsItalic700woff2 from '../../../../client/fonts/poppins/Poppins-BoldItalic.woff2';
// Extra Bold
import poppins800woff from '../../../../client/fonts/poppins/Poppins-ExtraBold.woff';
import poppins800woff2 from '../../../../client/fonts/poppins/Poppins-ExtraBold.woff2';
import poppinsItalic800woff from '../../../../client/fonts/poppins/Poppins-ExtraBoldItalic.woff';
import poppinsItalic800woff2 from '../../../../client/fonts/poppins/Poppins-ExtraBoldItalic.woff2';
const poppins = css `
  @font-face {
    font-family: 'Poppins';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url(${poppins400woff2}) format('woff2'), url(${poppins400woff});
  }
  @font-face {
    font-family: 'Poppins';
    font-weight: 400;
    font-style: italic;
    font-display: swap;
    src: url(${poppinsItalic400woff2}) format('woff2'), url(${poppinsItalic400woff});
  }
  @font-face {
    font-family: 'Poppins';
    font-weight: 600;
    font-style: normal;
    font-display: swap;
    src: url(${poppins600woff2}) format('woff2'), url(${poppins600woff});
  }
  @font-face {
    font-family: 'Poppins';
    font-weight: 600;
    font-style: italic;
    font-display: swap;
    src: url(${poppinsItalic600woff2}) format('woff2'), url(${poppinsItalic600woff});
  }
  @font-face {
    font-family: 'Poppins';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    src: url(${poppins700woff2}) format('woff2'), url(${poppins700woff});
  }
  @font-face {
    font-family: 'Poppins';
    font-weight: 700;
    font-style: italic;
    font-display: swap;
    src: url(${poppinsItalic700woff2}) format('woff2'), url(${poppinsItalic700woff});
  }
  @font-face {
    font-family: 'Poppins';
    font-weight: 800;
    font-style: normal;
    font-display: swap;
    src: url(${poppins800woff2}) format('woff2'), url(${poppins800woff});
  }
  @font-face {
    font-family: 'Poppins';
    font-weight: 800;
    font-style: italic;
    font-display: swap;
    src: url(${poppinsItalic800woff2}) format('woff2'), url(${poppinsItalic800woff});
  }
`;
export default poppins;
